/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuSelector_viewer = {
    readonly isSkyscraperAdEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenu_viewer">;
    readonly " $refType": "SbRespRefineMenuSelector_viewer";
};
export type SbRespRefineMenuSelector_viewer$data = SbRespRefineMenuSelector_viewer;
export type SbRespRefineMenuSelector_viewer$key = {
    readonly " $data"?: SbRespRefineMenuSelector_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuSelector_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuSelector_viewer",
  "selections": [
    {
      "alias": "isSkyscraperAdEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenu_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'd3a47ebbc267d4afe1733afffd5946ac';
export default node;
